import { configureStore } from "@reduxjs/toolkit";
import ownerReducer from "./features/ownerSlice";
import orderReducer from "./features/orderSlice";
import productReducer from "./features/productSlice";
import categoryReducer from "./features/categorySlice";
import invoiceReducer from "./features/invoiceSlice";

export default configureStore({
  reducer: {
    owner: ownerReducer,
    order: orderReducer,
    product: productReducer,
    category: categoryReducer,
    invoice: invoiceReducer,
  },
});
